<template>
  <div class="result">
    <div v-if="noData" class="xy-phone-no-data" style="margin:20% auto 0;">
      <img src="@/assets/basic/moblie-no-data.png" />
      <p style="font-size:14Px;">暂无结果展示，请评价学生。</p>
    </div>
    <div v-else>
      <div v-if="obj.isSettingGroup">
        <div v-for="(item,index) in list" :key="index" class="cards">
          <div class="title">
            <p>{{item.GroupName}}</p>
            <div style="margin-right:20px;">
              <span>小组得分 <span>{{item.GroupValue}}</span></span>
              <span>小组排名 <span>{{item.GroupRank}}</span></span>
              <span>小组排名积分 <span>{{item.GroupRankingValue}}</span></span>
            </div>
          </div>
          <div class="avatar">
            <div v-for="(item1,index1) in item.StudentScoreInfo" :key="index1">
              <Avatar :isSettingGroup="true" :user="item1"></Avatar>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="avatar singer">
        <div v-for="(item,index) in list" :key="index">
          <Avatar style="margin-top:20px;" :isSettingGroup="false" :user="item"></Avatar>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Avatar from './Avatar'
  import { Toast } from 'vant';
  export default {
    name: '',
    components: {
      Avatar
    },
    data () {
      return {
        noData:false,
        list:[],
        obj:{}
      }
    },
    created () {
      this.obj = this.$store.state.evaluation.ipadAverageObj
      if(this.obj.isSettingGroup){
        this.getStudentDatahas()
      }else{
        this.getStudentDatano()
      }
    },
    mounted () {},
    methods : {
      async getStudentDatahas(){
        Toast.loading({
          duration:'3500',
          message: '加载中...',
          className: 'ipad_toast',
          forbidClick: true
        })
        let res = await this.xyapi.get(`${this.$store.state.apiPath}/api/GradeAndClassStatistics/GetGroupAndStudentScoreInfo`, {
          schoolDistrictID: this.obj.SchoolDistrictID,
          academicSessionID: this.obj.AcademicSessionID,
          groupType:'1',
          coursePlanAID:this.obj.CoursePlanAID,
          coursePlanAIDType:this.obj.CoursePlanAIDType,
          classTableGenerateBaseID:this.obj.ClassTableGenerateBaseID,
          studentOrganizationID:this.obj.StudentOrganizationID,
        })
        if (res.success) {
          if (res.data.length > 0) {
            this.list=res.data
          }else{
            this.noData=true
          }
        }
        Toast.clear();
      },
      // 获取学生列表 无分组
      async getStudentDatano () {
        let params = {
          coursePlanAID: this.obj.CoursePlanAID,
          classTableGenerateBaseID: this.obj.ClassTableGenerateBaseID,
          coursePlanAIDType: this.obj.CoursePlanAIDType,
          studentOrganizationID: this.obj.StudentOrganizationID,
        }
         Toast.loading({
          duration:'3500',
          message: '加载中...',
          className: 'ipad_toast',
          forbidClick: true
        })
        let res = await this.xyapi.get(`${this.$store.state.apiPath}/api/EvaluateStudent/GetStudentScoreList`, params)
        if (res.success) {
          if (res.data.length > 0) {
            this.list = res.data
          }else{
            this.noData=true
          }
        }
        Toast.clear();
      },
    }
  }
</script>
<style lang='less' scoped>
.result{
  padding:10px;
  padding-bottom:30px;
  .cards{
    background: #fff;
    border-radius: 8px;
    margin-bottom: 10px;
    padding-bottom: 10px;
    .title{
      display: flex;
      justify-content: space-between;
      >p{
        font-size: 18Px;
        font-weight: 700;
        margin:20px 0 18px 20px;
        width:50%;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        word-break: break-all;
      }
      >div{
        >span{
          font-size: 14Px;
          color:rgba(26,26,26,0.65);
          margin-right:10px;
          span{
            font-size: 18Px;
            color:#E28D30 ;
          }
        }
      }
    }
  }
  .avatar{
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    padding:0 20px;
  }
  .singer{
     background: #fff;
  }
}
</style>
